import { useState } from "react";

import type { LessonResult } from "../../lessonTypes";
import LessonComplete from "./LessonComplete";
import StreakComplete from "./StreakComplete";

interface CompletionFlowProps {
    result: LessonResult | null;
    showRewards: boolean; // False for a replay
    onExit: () => void; // Called after the last finish screen
}

// The screens after a lesson or project: "completed", then the streak screen when the streak grew
const CompletionFlow = ({ result, showRewards, onExit }: CompletionFlowProps) => {
    const [showStreak, setShowStreak] = useState(false);

    if (showStreak) return <StreakComplete streak={result?.streak} onContinue={onExit} />;

    return (
        <LessonComplete
            credit={result?.credit}
            xp={result?.xp}
            showRewards={showRewards}
            onContinue={() => (result?.streakChanged ? setShowStreak(true) : onExit())}
        />
    );
};

export default CompletionFlow;